import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Card } from "react-bootstrap";
import { getLanguageJSON } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { FadeLoader } from "react-spinners";

export default function LanguageJsonModal({ show, handleClose, languageCode }) {
  const { loading, languageJSON } = useSelector(({ Language }) => Language);
  const [groupedData, setGroupedData] = useState({});
  const dispatch = useDispatch();

  const groupByPrefix = (data) => {
    const grouped = {};
    Object.entries(data || {}).forEach(([key, value]) => {
      const [prefix, rest] = key.split(".");
      if (!grouped[prefix]) grouped[prefix] = [];
      grouped[prefix].push({ key: rest, fullKey: key, value });
    });
    return grouped;
  };

  useEffect(() => {
    if (languageJSON && Object.keys(groupedData).length === 0) {
      const grouped = groupByPrefix(languageJSON);
      setGroupedData(grouped);
    }
  }, [languageJSON]);

  useEffect(() => {
    if (!show) {
      setGroupedData({});
    }
  }, [show]);

  useEffect(() => {
    if (languageCode) {
      dispatch(getLanguageJSON({ data: { languageCode } }));
    }
  }, [languageCode]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      size="xl"
      scrollable
    >
      <Modal.Header closeButton>
        <h5 className="mb-0">Language JSON Viewer</h5>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <FadeLoader />
          </div>
        ) : (
          <div className="language-json-masonry">
            {Object.entries(groupedData).map(([group, entries], index) => (
              <div className="masonry-card" key={index}>
                <Card>
                  <Card.Body>
                    <Card.Title>{group}</Card.Title>
                    <ul className="list-unstyled">
                      {entries.map((entry, idx) => (
                        <li key={idx}>
                          <strong>{entry.key}</strong>: {entry.value}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
